import { useEffect, useState } from 'react';
import { appVersion } from '../version';

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Compara periódicamente la versión compilada (src/version.ts) contra
 * public/version.json en el servidor. Si el servidor tiene una versión
 * distinta, hay un despliegue nuevo y el usuario debe refrescar: los bundles
 * con hash viejo ya no existen y la app quedaría rota en la próxima carga.
 *
 * Chequea al montar, cada 5 minutos y cada vez que la pestaña vuelve a
 * estar visible (el caso típico: el usuario deja la pestaña abierta días).
 */
export const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let disposed = false;

    const check = async () => {
      try {
        const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const { version } = await res.json();
        if (!disposed && version && version !== appVersion) {
          setUpdateAvailable(true);
        }
      } catch {
        // Sin red o servidor caído: no molestar al usuario por esto.
      }
    };

    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };

    const intervalId = setInterval(check, CHECK_INTERVAL_MS);
    document.addEventListener('visibilitychange', onVisible);
    check();

    return () => {
      disposed = true;
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return updateAvailable;
};

export default useVersionCheck;
